<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.pmName" style="width: 140px;" size="small " placeholder="请输入抽奖活动名称"
                        clearable></el-input>
                    <!-- <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select> -->
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="businessOpportunitiesClicks()">转商机申请</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="claimClicks(4)">批量审核</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px"
                        @click="BoxOpen">新建抽奖活动</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="pmId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑抽奖活动' : '新增抽奖活动'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="抽奖活动名称" prop="pmName">
                            <el-input v-model="form.pmName" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="描述" prop="pmDes">
                            <el-input v-model="form.pmDes" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :title="VoteEdit ? '编辑投票' : '新增投票'" :visible.sync="voteDiaLog" width="70%" top="8vh">
                <el-form ref="formVote" :model="formV" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="投票标题" prop="pvmTitle">
                            <el-input v-model="formV.pvmTitle" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="投票时间" prop="pvmTimeStart">
                            <el-date-picker v-model="formV.pvmTimeStart" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" style="width: 45%">
                            </el-date-picker>
                            -
                            <el-date-picker v-model="formV.pvmTimeEnd" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" style="width: 45%">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="投票形式" prop="pvmType">
                            <el-radio-group v-model="formV.pvmType">
                                <el-radio :label="1">单选</el-radio>
                                <el-radio :label="2">多选</el-radio>
                            </el-radio-group>
                            <div style="width: 100%;" v-if="formV.pvmType == 2">
                                最多选: <el-input-number v-model="formV.pvmTypeMultiMax" :min="2"
                                    label="请输入"></el-input-number>项
                            </div>
                            <div style="width: 100%;margin: 20px 0;" v-if="formV.pvmType == 2">
                                最少选: <el-input-number v-model="formV.pvmTypeMultiMin" :min="2"
                                    label="请输入"></el-input-number>项
                            </div>
                        </el-form-item>
                        <el-form-item label="状态" prop="pvmStatus">
                            <el-radio-group v-model="formV.pvmStatus">
                                <el-radio :label="1">草稿</el-radio>
                                <el-radio :label="2">发布</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="VoteHandleClose">取 消</el-button>
                    <el-button type="primary" @click="VoteSureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :title="VoteItemEdit ? '编辑投票项' : '新增投票项'" :visible.sync="voteItemDiaLog" width="70%" top="8vh">
                <el-form ref="formVoteItem" :model="formVI" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="选项值" prop="pviValue">
                            <el-input v-model="formVI.pviValue" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="排序" prop="pviOrder">
                            <el-input v-model="formVI.pviOrder" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="VoteItemHandleClose">取 消</el-button>
                    <el-button type="primary" @click="VoteItemSureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="投票" :visible.sync="isVote" width="80%" top="8vh">
                <div style="width: 100%; height: 60px;display: flex;flex-direction: row-reverse;">
                    <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                        <el-button type="success" size="small" style="margin-right: 30px"
                            @click="voteOpen">新建投票活动</el-button>
                        <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    </el-row>
                </div>
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="voteData" :columns="VoteColumns" :table-data="voteData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="pvmId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="voteData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
            <el-dialog title="投票项" :visible.sync="isVoteItem" width="80%" top="8vh">
                <div style="width: 100%; height: 60px;display: flex;flex-direction: row-reverse;">
                    <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                        <el-button type="success" size="small" style="margin-right: 30px"
                            @click="voteItemClick">新建投票项</el-button>
                        <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    </el-row>
                </div>
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="voteItemData" :columns="VoteItemColumns" :table-data="voteItemData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="pviId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="voteItemData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>

import {
    addPzMain, deletePzMain, getPzMainList, updatePzMain, getPzVoteMainList, addPzVoteMain, updatePzVoteMain, deletePzVoteMain, getPzVoteItemList,
    addPzVoteItem, deletePzVoteItem, updatePzVoteItem,

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            pvmId: '',
            formVI: {

            },
            voteItemDiaLog: false,
            VoteItemEdit: false,
            isVoteItem: false,
            voteItemData: [],
            VoteItemColumns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "pviValue",
                    key: "pviValue",
                    fixed: 'left',
                    title: "选项",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pviOrder",
                    key: "pviOrder",
                    title: "排序",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.VoteItemHandleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.VoteItemHandleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }

                            </span>
                        );
                    },
                },
            ],
            formV: {},
            pmId: '',
            VoteColumns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "pvmTitle",
                    key: "pvmTitle",
                    fixed: 'left',
                    title: "投票标题",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmTimeStart",
                    key: "pvmTimeStart",
                    title: "投票开始时间",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmTimeEnd",
                    key: "pvmTimeEnd",
                    title: "投票结束时间",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmType",
                    key: "pvmType",
                    title: "投票形式(1单选 2多选)",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmTypeMultiMin",
                    key: "pvmTypeMultiMin",
                    title: "多选最少",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmTypeMultiMax",
                    key: "pvmTypeMultiMax",
                    title: "多选最多",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pvmStatus",
                    key: "pvmStatus",
                    title: "状态(1草稿 2发布)",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.gotoVotePh(row)}
                                    >
                                        排行榜
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.gotoVoteItem(row)}
                                    >
                                        投票项
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.VotehandleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.VotehandleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ],
            voteDiaLog: false,
            VoteEdit: false,
            isVote: false,
            voteData: [],
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'pmId',
            dialog: false,
            edit: false,
            form: {
                pmName: '',
                pmDes: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "pmName",
                    key: "pmName",
                    fixed: 'left',
                    title: "抽奖活动名称",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "pmDes",
                    key: "pmDes",
                    title: "描述",
                    width: 150,
                    align: "center",
                    // edit: true,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.gotoVote(row)}
                                    >
                                        投票
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.gotoActivity(row)}
                                    >
                                        进入活动
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                naLevel: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        gotoVotePh(row) {
            this.isVote = false;
            this.$router.push({
                path: '/bigVotePh',
                query: {
                    pvmId: row.pvmId
                }
            })
        },
        voteItemClick() {
            this.formVI.pvmId = this.pvmId;
            this.voteItemDiaLog = true;
        },
        VoteItemGetList() {
            getPzVoteItemList({ pvmId: this.pvmId }).then(res => {
                this.voteItemData = res.data;
            })
        },
        gotoVoteItem(row) {
            getPzVoteItemList({ pvmId: row.pvmId }).then(res => {
                this.pvmId = row.pvmId;
                this.voteItemData = res.data;
                this.isVoteItem = true;
            })
        },
        VoteItemHandleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deletePzVoteItem({ pviId: row.pviId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.VoteItemGetList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        VoteItemHandleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.voteItemDiaLog = true;
            this.VoteItemEdit = true;
            this.$nextTick(() => {
                this.formVI = data;
            })
        },
        VotehandleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deletePzVoteMain({ pvmId: row.pvmId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.VoteGetList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        VotehandleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.voteDiaLog = true;
            this.VoteEdit = true;
            this.$nextTick(() => {
                this.formV = data;
            })
        },
        // 关闭弹框
        VoteItemHandleClose() {
            this.voteItemDiaLog = false;
            this.VoteItemEdit = false;
            this.$refs['formVoteItem'].resetFields();
        },
        VoteItemSureBtn() {
            if (!this.VoteItemEdit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const nowForm = JSON.parse(JSON.stringify(this.formVI))
                        addPzVoteItem(nowForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.VoteItemHandleClose()
                                this.VoteItemGetList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const nowForm = JSON.parse(JSON.stringify(this.formVI))
                        updatePzVoteItem(nowForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.VoteItemHandleClose()
                                this.VoteItemGetList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        // 关闭弹框
        VoteHandleClose() {
            this.voteDiaLog = false;
            this.VoteEdit = false;
            this.$refs['formVote'].resetFields();
        },
        VoteSureBtn() {
            if (!this.VoteEdit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const nowForm = JSON.parse(JSON.stringify(this.formV))
                        addPzVoteMain(nowForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.VoteHandleClose()
                                this.VoteGetList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const nowForm = JSON.parse(JSON.stringify(this.formV))
                        updatePzVoteMain(nowForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.VoteHandleClose()
                                this.VoteGetList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        voteOpen() {
            this.voteDiaLog = true;
            this.formV.pmId = this.pmId;
        },
        toAddArray() {
            this.array.push({ qtiValue: '', qtiIsAnswer: 1, id: this.array.length + 1 })
        },
        // 删除选项
        toDeleteArray(index, row) {
            if (this.array.length == 1) {
                return
            }
            this.array.splice(index, 1)
        },
        VoteGetList() {
            getPzVoteMainList({ pmId: this.pmId }).then(res => {
                this.voteData = res.data;
            })
        },
        gotoVote(row) {
            getPzVoteMainList({ pmId: row.pmId }).then(res => {
                this.pmId = row.pmId
                this.voteData = res.data;
                this.isVote = true;
            })
        },
        gotoActivity(row) {
            this.$router.push({
                path: '/DrawForAPrize',
                query: {
                    pmId: row.pmId
                }
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deletePzMain({ pmId: row.pmId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addPzMain(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updatePzMain(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.pmId = row.pmId
                    //console.log(jsonObj);
                    updatePzMain(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getPzMainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getPzMainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getPzMainList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>